import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa6";
import "./SectorMorePage.css";


export default function SectorMorePage() {


  const navigate = useNavigate();

  const [sectors, setSectors] = useState([]);

 useEffect(() => {

  const sector = localStorage.getItem("selectedSector");
  const sectorType = localStorage.getItem("selectedSectorType");

  if (!sector || !sectorType) return;

  fetch(
    `${process.env.REACT_APP_BACKEND_URL}/api/mind-mapping/sector-descriptions-next?sector=${encodeURIComponent(sector)}&sectorType=${encodeURIComponent(sectorType)}`
  )
    .then(res => res.json())
    .then(data => setSectors(data))
    .catch(err => console.error(err));

}, []);


 return (
  <div className="sector-page">

  <div className="sector-header">

    <button
      className="sector-back-btn"
      onClick={() => navigate(`/mind-mapping/sec-b`)}
    >
      <FaArrowLeft />
    </button>

    <h1 className="sector-title">Sector Descriptions</h1>

</div>


    {sectors.length === 0 && (
      <p className="sector-empty">
        No additional sector insights available.
      </p>
    )}

   <ul className="sector-list">
  {sectors.map((item,i)=>(
    <li key={i} className="sector-item">
      {item.description}
    </li>
  ))}
</ul>


  </div>
);

}
